import { Controller } from "@hotwired/stimulus"
import { bindClickOutside } from "../utils/click_outside"

// Pure Tailwind dropdown controller - no Bootstrap dependencies
export default class extends Controller {
  static targets = ["menu", "icon"]

  connect() {
    this.unbindClickOutside = bindClickOutside(this.element, () => {
      if (this.isOpen()) this.hide()
    })

    // Hide menu on initial load
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")
    }
  }

  disconnect() {
    this.unbindClickOutside()
  }

  toggle(event) {
    if (event) {
      event.preventDefault()
      event.stopPropagation()
    }

    if (this.isOpen()) {
      this.hide()
    } else {
      // Close all other dropdowns first
      this.closeAllOtherDropdowns()
      this.show()
    }
  }

  show() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("hidden")

      // Rotate icon if it exists
      if (this.hasIconTarget) {
        this.iconTarget.classList.add("transform", "rotate-180")
      }
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden")

      // Reset icon rotation if it exists
      if (this.hasIconTarget) {
        this.iconTarget.classList.remove("transform", "rotate-180")
      }
    }
  }

  closeAllOtherDropdowns() {
    const allDropdowns = this.application.controllers.filter(
      controller => controller.context.identifier === 'dropdown-pure' && controller !== this
    )

    allDropdowns.forEach(controller => {
      if (controller.isOpen && controller.isOpen()) {
        controller.hide()
      }
    })
  }

  isOpen() {
    return this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")
  }
}